import { ModalStore } from 'ui/base/modal';
import { StringStore } from 'ui/base/input/store';

export class CountryStore {
  country: StringStore;
  prefix: StringStore;
  search: StringStore;
  modal: ModalStore;

  constructor(country: string, prefix: string) {
    this.country = new StringStore(country);
    this.prefix = new StringStore(prefix);
    this.modal = new ModalStore(false);
    this.search = new StringStore('');
  }
}
